import { GridTableRow } from 'components/grid-table';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const SortableTableRow: React.FC<{
  id: number;
  children: (dragListeners: any) => React.ReactNode;
}> = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const rowStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <GridTableRow ref={setNodeRef} style={rowStyle} {...attributes}>
      {children(listeners)}
    </GridTableRow>
  );
};
